import { EBitfStoreActions } from '@common/enums';
export enum EWebStoreActions {
  UPDATE_FS_BREADCRUMBS = 'UPDATE_FS_BREADCRUMBS',
  SET_FS_CONFIGURATION = 'SET_FS_CONFIGURATION',
  SET_CURRENT_FS = 'SET_CURRENT_FS',
}

export const eStoreActions = { ...EBitfStoreActions, ...EWebStoreActions };
